var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 21,
    fill: "#ED5240"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.439 26.7626L26.2895 18.6131C25.1871 17.5106 23.3021 18.2914 23.3021 19.8505L23.3021 36.1495C23.3021 37.7086 25.1871 38.4894 26.2895 37.3869L34.439 29.2374C35.1225 28.554 35.1225 27.446 34.439 26.7626Z",
    fill: "#CC4737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f1333f2dec81fe00cf368843cf845adc.svg";
export { ForwardRef as ReactComponent };